export default __webpack_public_path__ + "static/media/thumbnail.af4f0a41.png";